import { SET_MISSION, RESET } from './actionTypes'

export function reset() {

  return { 
    type : RESET
  }
}

export function setActiveMission( mission, options = {} ) {

  const { 
          redirectUrl =  otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=goToProfile',
        } = options
        
  const url = new URL( redirectUrl )

  url.searchParams.set( 'missionId', mission.missionId ) 

  return async ( dispatch, getState ) => {

    return new Promise((resolve,reject) => {

      otuApp.triggerAjaxGet( url.toString(),{
        callback : function ( success ) {
          resolve();
          },
        errorCallback : function () {
          reject();
        }
        } )
    })
  }
}